((LandingPageController) => {
	'use strict';

	LandingPageController.$inject = ['$scope', 'dcyHTTPRequestService', 'dcyDialogFactory', '$timeout', 'dcyLandingPageFactory', 'dcyNavigationManagerUtilsFactory'];
	
	angularApp.dcyApplication.register.controller('landingPageCtrl', ($scope, dcyHTTPRequestService, dcyDialogFactory, $timeout, dcyLandingPageFactory, dcyNavigationManagerUtilsFactory) => new LandingPageController($scope, dcyHTTPRequestService, dcyDialogFactory, $timeout, dcyLandingPageFactory, dcyNavigationManagerUtilsFactory));
})(window.LandingPageController);